// =============================================================================
// PRE-SPARRING QUESTIONS
// =============================================================================
//
// Opt-in context-gathering questions before sparring starts.
// Antwoorden worden als context meegegeven aan AI, geen opslag.
//
// =============================================================================

import { QuestionWithVariants } from '../shared/languageVariants.types';

/**
 * Pre-sparring questions per domein
 */
export const PRE_SPARRING_QUESTIONS: QuestionWithVariants[] = [
  {
    id: 'marketing',
    question: {
      practical: 'Hoe trek je nu aandacht naar je werk of bedrijf?',
      neutral: 'Wat is je huidige aanpak rond marketing en zichtbaarheid?',
      reflective: 'Hoe voelt het om je werk of bedrijf zichtbaar te maken?',
    },
  },
  {
    id: 'team',
    question: {
      practical: 'Wie werkt er met je mee aan dit doel?',
      neutral: 'Wat is de rol van anderen bij dit doel?',
      reflective: 'Hoe ervaar je samenwerking rond dit doel?',
    },
  },
  {
    id: 'structure',
    question: {
      practical: 'Welke systemen of processen heb je al opgezet?',
      neutral: 'Hoe organiseer je het werk rond dit doel?',
      reflective: 'Wat helpt je om overzicht te houden?',
    },
  },
  {
    id: 'knowledge',
    question: {
      practical: 'Welke kennis of vaardigheden mis je nog?',
      neutral: 'Waar loop je tegen aan qua kennis of ervaring?',
      reflective: 'Wat zou je graag beter begrijpen of kunnen?',
    },
  },
];

/**
 * Domain labels voor UI
 */
export const DOMAIN_LABELS: Record<string, string> = {
  marketing: 'Marketing & Zichtbaarheid',
  team: 'Team & Samenwerking',
  structure: 'Structuur & Systemen',
  knowledge: 'Kennis & Vaardigheden',
};
